//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'report-center-create',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    FormComponent: FormComponent
  }
};